// @ts-check
import { HugeiconsIcon } from "@hugeicons/react";
import { TaskDone01Icon, Megaphone02Icon, Mortarboard01Icon, CheckListIcon } from "@hugeicons/core-free-icons/index";

const DEFAULT_SIZE = 16;
const DEFAULT_COLOR = "currentColor";
const DEFAULT_STROKE_WIDTH = 1.75;

export function PostIcon({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, strokeWidth = DEFAULT_STROKE_WIDTH }) {
    return (
        <HugeiconsIcon icon={Megaphone02Icon} size={size} color={color} strokeWidth={strokeWidth} />
    );
}

export function FormIcon({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, strokeWidth = DEFAULT_STROKE_WIDTH }) {
    return (
        <HugeiconsIcon icon={TaskDone01Icon} size={size} color={color} strokeWidth={strokeWidth} />
    );
}

export function CourseIcon({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, strokeWidth = DEFAULT_STROKE_WIDTH }) {
    return (
        <HugeiconsIcon icon={Mortarboard01Icon} size={size} color={color} strokeWidth={strokeWidth} />
    );
}

export function TaskIcon({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, strokeWidth = DEFAULT_STROKE_WIDTH }) {
    return (
        <HugeiconsIcon icon={CheckListIcon} size={size} color={color} strokeWidth={strokeWidth} />
    );
}